export const useLocale = () => {
  const { locale, locales, setLocale } = useI18n()
  const switchLocalePath = useSwitchLocalePath()
  const { lang } = useSite()

  // 使用 siteConfig 的 lang 過濾 i18n 支援的語言
  const supportedLocales = computed(() => {
    const i18nLocales = locales.value.map((l) => l.code)
    const siteLangs = lang.value || []
    // 只顯示 siteConfig 中有設定且 i18n 也支援的語言
    return siteLangs.filter((l) => i18nLocales.includes(l))
  })

  // Client 端載入後同步 cookie 語系
  const syncLocaleFromCookie = async () => {
    if (!import.meta.client) return

    const localeCookie = useCookie('i18n_locale')
    const cookieLocale = localeCookie.value

    if (!cookieLocale) return
    if (cookieLocale === locale.value) return
    if (!supportedLocales.value.includes(cookieLocale)) return

    await setLocale(cookieLocale)
  }

  const changeLocale = async (newLocale) => {
    if (!supportedLocales.value.includes(newLocale)) {
      console.warn(`[useLocale] Locale ${newLocale} is not supported. Supported:`, supportedLocales.value)
      return false
    }

    // 儲存語系到 cookie
    const localeCookie = useCookie('i18n_locale', {
      maxAge: 60 * 60 * 24 * 365,
      sameSite: 'lax',
    })
    localeCookie.value = newLocale

    await setLocale(newLocale)
    return true
  }

  const getLocalePath = (code) => {
    return switchLocalePath(code)
  }

  return {
    locale,
    locales,
    supportedLocales,
    changeLocale,
    getLocalePath,
    syncLocaleFromCookie,
  }
}